import { GET, POST } from "../../../../module/services/fetch";
import { map } from "rxjs/operators";
import { IPropagationStd } from "./constants";

export const fetchPropagations = () => {
  return GET('authentication/propagation') //ADMIN no ?????
        .pipe(map((res: any) => res));
};

export const postUpdatePropagation = (data: IPropagationStd[]) => {
  return POST('authentication/propagation', data)
        .pipe(map((res: any) => res));
};

export const postDeletePropagation = (ids: string[]) => {
  return POST('authentication/propagation/delete', ids)
        .pipe(map((res: any) => res));
};